import React from 'react';
import { createRoot } from 'react-dom/client';
import AmazonImportModal from './AmazonImportModal';
import { authenticatedPost } from './utils/apiUtils';

let modalRoot = null;

function showImportModal(orderObjs) {
  // Dispatch a custom event to trigger the modal in Home.js
  window.dispatchEvent(new CustomEvent('amnathrig-show-import-modal', { detail: { orders: orderObjs } }));
}

window.addEventListener('message', (event) => {
  if (!event.data || event.source !== window) return;
  if (event.data.type !== 'IMPORT_AMZ_ORDER') return;

  // Validate origin
  try {
    if (event.origin !== window.location.origin) {
      console.warn('Ignored import from different origin', event.origin);
      return;
    }
  } catch (e) {}

  // Support batch import: if payload is array, use it; else wrap single
  let orderObjs = [];
  if (Array.isArray(event.data.payload)) {
    orderObjs = event.data.payload;
  } else if (event.data.payload && (event.data.payload.order || event.data.payload.metadata)) {
    orderObjs = [event.data.payload];
  } else if (event.data.payload) {
    orderObjs = [event.data.payload];
  }
  if (!orderObjs.length) return;
  showImportModal(orderObjs);
});
